import { Link } from "react-router-dom";
import { Mail, Phone, CalendarClock } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT, SEO_CITIES_TEXT } from "@/lib/data";

const Footer = () => {
  return (
    <footer className="bg-ink text-white mt-0" data-testid="site-footer">
      <div className="container-tm py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <Logo variant="light" className="h-16 md:h-20 w-auto mb-6" />
          <p className="text-sm font-sans text-white/65 leading-relaxed max-w-xs">
            La conciergerie premium pour vos locations type Airbnb en Bretagne, Côte d'Émeraude & Morbihan. Deux équipes locales dédiées.
          </p>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.25em] font-semibold text-gold mb-5">
            Tout savoir sur nous
          </h4>
          <ul className="space-y-3 font-sans text-sm text-white/75">
            <li><Link to="/pourquoi-nous" className="hover:text-gold transition-colors" data-testid="footer-link-pourquoi-nous">Pourquoi nous vs les autres</Link></li>
            <li><Link to="/engagements" className="hover:text-gold transition-colors" data-testid="footer-link-engagements">Engagements</Link></li>
            <li><a href="/mentions-legales" className="hover:text-gold transition-colors" data-testid="footer-link-mentions">Mentions légales</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.25em] font-semibold text-gold mb-5">
            Besoin de plus d'info ?
          </h4>
          <ul className="space-y-3 font-sans text-sm text-white/75">
            <li><a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/brochure`}
                download="terre-et-mer-conciergerie-plaquette.pdf"
                className="hover:text-gold transition-colors inline-flex items-center gap-2"
                data-testid="footer-link-plaquette"
              >
                Plaquette présentation (PDF)
              </a>
            </li>
            <li><Link to="/resultats" className="hover:text-gold transition-colors" data-testid="footer-link-resultats">Résultats clients</Link></li>
            <li><Link to="/blog" className="hover:text-gold transition-colors" data-testid="footer-link-blog">Blog conseils propriétaires</Link></li>
            <li><Link to="/faq" className="hover:text-gold transition-colors" data-testid="footer-link-faq">Foire aux questions</Link></li>
            <li><Link to="/parrainage" className="hover:text-gold transition-colors inline-flex items-center gap-1.5" data-testid="footer-link-parrainage">
              Parrainage <span className="text-[9px] uppercase tracking-[0.2em] bg-gold/20 text-gold px-1.5 py-0.5 rounded-full font-semibold">100 € offerts</span>
            </Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors" data-testid="footer-link-contact">Nous contacter</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.25em] font-semibold text-gold mb-5">
            Restons en contact
          </h4>
          <ul className="space-y-3 font-sans text-sm text-white/75">
            <li className="flex items-center gap-3">
              <Mail size={16} strokeWidth={1.6} className="text-gold shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-gold transition-colors break-all" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} strokeWidth={1.6} className="text-gold shrink-0" />
              <a href={CONTACT.phoneHref} className="hover:text-gold transition-colors" data-testid="footer-phone">
                {CONTACT.phone}
              </a>
            </li>
          </ul>

          <div className="mt-6 pt-5 border-t border-white/10" data-testid="footer-hours">
            <p className="text-[10px] uppercase tracking-[0.25em] font-semibold text-gold mb-3">
              Service commercial
            </p>
            <ul className="space-y-1.5 font-sans text-xs text-white/65">
              {CONTACT.hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-3">
                  <span>{h.day}</span>
                  <span className="text-white/85">{h.slots}</span>
                </li>
              ))}
            </ul>
          </div>

          <a
            href={CONTACT.calendly}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-calendly-cta"
            className="mt-6 inline-flex items-center gap-2 bg-gold hover:bg-gold-500 text-white text-[11px] uppercase tracking-[0.18em] font-semibold rounded-full px-4 py-2.5 transition-colors"
          >
            <CalendarClock size={13} strokeWidth={2} />
            Prendre RDV 15 min
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-tm py-6 text-[11px] font-sans text-white/40 leading-relaxed">
          <p className="mb-3" data-testid="footer-seo-line">
            {SEO_CITIES_TEXT.join(" · ")}
          </p>
          <p data-testid="footer-mention">
            © {new Date().getFullYear()} TERRE ET MER CONCIERGERIE est conçu et développé à Ploubalay (22) 🇫🇷
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
